import $ from 'jquery';
import { dataLayerEventExist } from '../site/helpers';

class ExpertiseFilter {
  constructor(selector) {
    this.container = $(selector);
    this.items = this.container.find('.filter-item');

    this._setListeners();
    // 1. Run the check immediately on load
    this._checkHashOnLoad();
  }

  _setListeners() {
    this.items.on('click', (event) => this._handleItemClick(event));
  }

  // 2. New method to handle URL anchors
  _checkHashOnLoad() {
    // Get the hash (e.g., "#web-design")
    const hash = window.location.hash;

    // Only proceed if a hash exists
    if (hash) {
      // Remove the '#' symbol to get just the slug
      const slug = hash.substring(1);

      // Find the item that matches this ID or data-slug
      // We use the ID we added in the PHP step
      const targetItem = this.items.filter(`#${slug}`);

      // If we found a matching item in this list
      if (targetItem.length > 0) {
        // Remove active from the default (first) item
        this.items.removeClass('active');

        // Add active to the linked item
        targetItem.addClass('active');

        // Optional: specific GTM event for direct link entry?
        // You can add that here if needed.

        // Optional: Scroll to the item (Browser does this natively with IDs,
        // but sometimes headers block it. Uncomment if needed)
        // $('html, body').animate({
        //     scrollTop: targetItem.offset().top - 100
        // }, 500);
      }
    }
  }

  _handleItemClick(event) {
    const target = $(event.currentTarget);

    // Safety check to ensure we are clicking a filter item
    if (!target.hasClass('filter-item')) return;

    const buttonText = target.find('h3').text(); // Grab text from h3 for consistency

    // Remove 'active' class from all items
    this.items.removeClass('active');

    // Add 'active' class to the clicked item
    target.addClass('active');

    // Update the URL without reloading page (Optional, but good UX)
    // This makes it so if they click an item and copy the URL, it links to that specific item
    const slug = target.attr('id');
    if (slug) {
      history.replaceState(null, null, `#${slug}`);
    }

    // GTM
    if (!dataLayerEventExist('expertiseCategoryClick', buttonText)) {
      window.dataLayer.push({
        event: 'expertiseCategoryClick',
        eventLabel: buttonText
      });
    }
  }
}

const expertiseFilter = (selector) => {
  $(selector).each((index, element) => {
    new ExpertiseFilter(element);
  });
};

export default expertiseFilter;
